import { create } from 'zustand';
import type { ReaderOption } from './readerTarget';

// The bridge between a connect flow and the reader picker modal
// (components/ReaderPicker/ReaderPickerModal.tsx, mounted once in pages/_app.js).
// A flow calls `requestReaderPick` and awaits the presenter's choice; the modal
// renders whatever request is pending. One request at a time: a second one
// cancels the first, which resolves null like a dismissal.

export interface ReaderPickRequest {
  options: ReaderOption[];
  preselect: string | null;
  resolve: (readerId: string | null) => void;
}

interface ReaderPickerStore {
  request: ReaderPickRequest | null;
  answer: (readerId: string | null) => void;
}

export const useReaderPickerStore = create<ReaderPickerStore>()((set, get) => ({
  request: null,
  answer: (readerId) => {
    const { request } = get();
    set({ request: null });
    request?.resolve(readerId);
  }
}));

/** Ask the presenter which browser should read; null if they dismiss it. */
export const requestReaderPick = (
  options: ReaderOption[],
  preselect: string | null
): Promise<string | null> => new Promise((resolve) => {
  useReaderPickerStore.getState().request?.resolve(null);
  useReaderPickerStore.setState({ request: { options, preselect, resolve } });
});
